module.exports = __webpack_public_path__ + "img/tubiao-44.923e4f6a.png";